import { render } from "./SubjectsPage.vue?vue&type=template&id=d542cf86"
import script from "./SubjectsPage.vue?vue&type=script&lang=js"
export * from "./SubjectsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__